import { render, staticRenderFns } from "./PenempatanList.vue?vue&type=template&id=0bbc47d3&scoped=true&"
import script from "./PenempatanList.vue?vue&type=script&lang=js&"
export * from "./PenempatanList.vue?vue&type=script&lang=js&"
import style0 from "./PenempatanList.vue?vue&type=style&index=0&id=0bbc47d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc47d3",
  null
  
)

export default component.exports